import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ManagedDepartmentFragment } from '@api/fragments'
import { IManagedDepartment } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface DeleteDepartmentFromManagedDepartmentsInput {
  id: string
  departmentId: string
}

interface IPayload {
  deleteDepartmentAdminEmployee: {
    employee: {
      departmentAdmins: IManagedDepartment[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IManagedDepartment[]>({
  handler: (data) => data.deleteDepartmentAdminEmployee.employee.departmentAdmins,
  name: 'Employee',
})

export default function deleteDepartmentFromManagedDepartments(
  input: DeleteDepartmentFromManagedDepartmentsInput
): Promise<IManagedDepartment[]> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation DeleteDepartmentFromManagedDepartments($input: DeleteDepartmentAdminEmployeeInput!) {
    deleteDepartmentAdminEmployee(input: $input) {
      employee {
        departmentAdmins {
          department {
            ...ManagedDepartmentFragment
          }
        }
      }
    }
  }
  ${ManagedDepartmentFragment}
`
